import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { FaSearch } from 'react-icons/fa';

import { getEntryMemberCount } from '../../../lib/func/ExportFunction';

const SearchLiveList = ({ list_live, list_searchLive, handleSearchValue, handleSelectedFunc }) => {
    const { t } = useTranslation();

    const [isChangedSearchValue, setChangedSearchValue] = useState(false);
    const [isClickSearchIcon, setClickSearchIcon] = useState(false);
    const [lSearchValue, setSearchValue] = useState("");

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            setClickSearchIcon(true);
            handleSearchClick({ keyword: lSearchValue });
        }
    }

    const handlePreventClick = (e) => {
        e.stopPropagation();
    }

    const handleSearchClick = () => {
        setClickSearchIcon(true);
        handleSearchValue({ keyword: lSearchValue });
    }

    const onChangeSearchValue = (e) => {
        setChangedSearchValue(true);
        setClickSearchIcon(false);
        setSearchValue(e.target.value);
        handleSearchValue({ keyword: e.target.value });
    }

    return (
        <div onClick={handlePreventClick}>
            <div className="input-area pt-1">
                <input type="text" className="search" placeholder={t("검색어_입력_메시지", { ns: "common" })} onChange={onChangeSearchValue} onKeyPress={handleKeyPress} />
                <div className="input-group-append ml-1" title={t("검색", { ns: "common" })} onClick={handleSearchClick}>
                    <span className="d-flex hiclasstv-btn-transparent b-none rounded p-1">
                        <FaSearch className="d-flex font-md white-text" />
                    </span>
                </div>
            </div>
            {
                isClickSearchIcon === true ?
                    <div className="py-1 hiclasstv-lightgrey">
                        <span className="px-2 font-weight-bold grey-text">{t("클래스", { ns: "live" })}</span>
                    </div> :
                    <></>
            }
            <div className="list-group scroll-show-active light hc-class-list hc-class-search-list" style={{ overflow: 'auto' }}>
                {
                    isChangedSearchValue === false ?
                        list_live.length > 0 ?
                            list_live.map(
                                live => (
                                    <div className={"d-flex list-group-hitem list-group-hitem-action p-2 justify-content-center align-items-center hc-class-row " + (live.liveStatus === "Y" ? "onair" : "offair") + (live.selectStatus === 'Y' ? " active" : "")} key={live.liveSeq}/* onClick={() => handleSelectedFunc((live.selectStatus === 'Y' ? { selectedFunc: (live.selectStatus === "Y" ? "UNSELECT_ACTIVE_LIVE" : "SELECT_ACTIVE_LIVE"), liveSeq: live.liveSeq } : { selectedFunc: "DISABLE" }))}*/>
                                        <div className="text-area flex-column align-items-start">
                                            <div className="text-area justify-content-start">
                                                <span className="hiclass-text" title={live.liveName}><b>{live.liveName}</b></span>
                                                <span className="hiclass-text hiclasstv-darkgrey-text">&nbsp;{getEntryMemberCount('handsUp', live.list_member)}</span>
                                            </div>
                                            <div className="hiclass-text hiclasstv-sub-grey-text small">
                                                {t("참여자", { ns: "live" })}&nbsp;<b>{live.list_member.length}</b>{t("명", { ns: "common" })}
                                            </div>
                                        </div>
                                        <div className="d-flex area-20 ml-2" onClick={handlePreventClick}>
                                            {
                                                live.liveStatus === "N" ?
                                                    <button type="button" className="btn btn-sm hiclasstv-main-grey white-text m-0 py-1 px-2 hc-live-state-btn offair" style={{ borderRadius: '1rem' }} onClick={() => handleSelectedFunc({ selectedFunc: "ONAIR", liveSeq: live.liveSeq, liveName: live.liveName, list_broadcast: live.list_broadcast })}>
                                                        {t("온에어", { ns: "live" })}
                                                    </button> :
                                                    <button type="button" className="btn btn-sm hiclasstv-main-blue white-text m-0 py-1 px-2 hc-live-state-btn onair" style={{ borderRadius: '1rem' }} onClick={() => handleSelectedFunc({ selectedFunc: "OFFAIR_TOGGLE", liveSeq: live.liveSeq })}>
                                                        {t("온에어", { ns: "live" })}
                                                    </button>
                                            }
                                        </div>
                                    </div>
                                )
                            ) :
                            <div className="view p-2 text-center grey-text">
                                {t("검색_결과_없음_메시지", { ns: "common" })}
                            </div> :
                        list_searchLive.length > 0 ?
                            list_searchLive.map(
                                live => (
                                    <div className={"d-flex list-group-hitem list-group-hitem-action p-2 justify-content-center align-items-center hc-class-row " + (live.liveStatus === "Y" ? "onair" : "offair") + (live.selectStatus === 'Y' ? " active" : "")} key={live.liveSeq} onClick={() => handleSelectedFunc((live.selectStatus === "Y" ? { selectedFunc: (live.selectStatus === "Y" ? "UNSELECT_ACTIVE_LIVE" : "SELECT_ACTIVE_LIVE"), liveSeq: live.liveSeq } : { selectedFunc: "DISABLE" }))}>
                                        <div className="text-area flex-column align-items-start">
                                            <div className="text-area justify-content-start">
                                                <span className="hiclass-text" title={live.liveName}><b>{live.liveName}</b></span>
                                                <span className="hiclass-text hiclasstv-darkgrey-text">&nbsp;{getEntryMemberCount('handsUp', live.list_member)}</span>
                                            </div>
                                            <div className="hiclass-text hiclasstv-sub-grey-text small">
                                                {t("참여자", { ns: "live" })}&nbsp;<b>{live.list_member.length}</b>{t("명", { ns: "common" })}
                                            </div>
                                        </div>
                                        <div className="d-flex area-20 ml-2" onClick={handlePreventClick}>
                                            {
                                                live.liveStatus === "N" ?
                                                    <button type="button" className="btn btn-sm hiclasstv-grey white-text m-0 py-1 px-2 hc-live-state-btn offair" style={{ borderRadius: '1rem' }} onClick={() => handleSelectedFunc({ selectedFunc: "ONAIR", liveSeq: live.liveSeq, liveName: live.liveName, list_broadcast: live.list_broadcast })}>
                                                        {t("온에어", { ns: "live" })}
                                                    </button> :
                                                    <button type="button" className="btn btn-sm green white-text m-0 py-1 px-2 hc-live-state-btn onair" style={{ borderRadius: '1rem' }} onClick={() => handleSelectedFunc({ selectedFunc: "OFFAIR_TOGGLE", liveSeq: live.liveSeq })}>
                                                        {t("온에어", { ns: "live" })}
                                                    </button>
                                            }
                                        </div>
                                    </div>
                                )
                            ) :
                            <div className="view p-2 text-center grey-text">
                                {t("검색_결과_없음_메시지", { ns: "common" })}
                            </div>
                }
            </div>
        </div>
    );
}

export default SearchLiveList;
